import { usePost } from "../api-client/usePost";
import { LeadFormData, LeadParams } from "../blocks/LeadForm/LeadFormModal";
import { useLanguage } from "../i18n/useLanguage";
import { useCart } from "../stores/hooks/useCart";
import { useSetInfoToast } from "../stores/hooks/useSetInfoToast";

// leadId is null when the API does not return it (older API builds).
export type CreatedQuoteContactLead = LeadFormData & { leadId: null | number };

type CreateQuoteContactLead = (
  params: LeadParams
) => Promise<CreatedQuoteContactLead>;

export const useCreateQuoteContactLead = (): CreateQuoteContactLead => {
  // A lead is a write: it goes as a form POST so the customer's details are not in
  // the URL, and the backend can drop the GET form of the route (TW-1122).
  const { send } = usePost<{ leadId?: number; success: boolean }>(
    "/retailSiteWebService/shopping/lead/createQuoteContactLead.php"
  );
  const cart = useCart();
  const [language] = useLanguage();
  const setInfoToast = useSetInfoToast();

  const createQuoteContactLead = async ({
    customerEmail,
    customerFirstName,
    customerLastName,
    customerMessage,
    customerPhone,
    customerVin,
    generatedBy,
    sendCustomerEmail,
  }: LeadParams): Promise<CreatedQuoteContactLead> => {
    const { payload } = await send({
      customerEmail,
      customerFirstName,
      customerLanguage: language,
      customerLastName,
      customerMessage,
      customerPhone,
      customerVin,
      generatedBy,
      orderNumber: String(cart?.orderNumber),
      sendCustomerEmail: String(sendCustomerEmail),
      targetDealerId: String(cart?.dealerId),
    });
    if (sendCustomerEmail) {
      setInfoToast({ message: "leadForm.successMessage" });
    }

    return {
      customerEmail,
      customerFirstName,
      customerLastName,
      customerMessage,
      customerPhone,
      customerVin,
      generatedBy,
      leadId: Number(payload?.leadId) || null,
    };
  };
  return createQuoteContactLead;
};
